module.exports = __webpack_public_path__ + "static/media/failed-skill-header.e629f754.png";